var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"position-relative util-content pa-8"},[_vm._t("header"),_vm._t("content"),_vm._t("actions"),_c('div',{staticClass:"position-absolute btn-close"},[_c('v-btn',{attrs:{"icon":"","color":"primary"},on:{"click":_vm.click}},[_c('v-icon',{staticClass:"font-size-32 white rounded-circle"},[_vm._v(" mdi-close-circle")])],1)],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }